import { SegmentGroup, SegmentGroupValueChangeDetails } from '@chakra-ui/react';
import { memo, useCallback } from 'react';

export type ChartInterval = '1D' | '1W' | '1M' | '1Y' | 'All';
const INTERVALS: ChartInterval[] = ['1D', '1W', '1M', '1Y', 'All'];

interface Props {
  onChange?: (interval: ChartInterval) => void;
  defaultValue?: ChartInterval;
  intervals?: ChartInterval[];
}

const ChartIntervals = ({ onChange, defaultValue = '1D', intervals = INTERVALS }: Props) => {
  const handleChange = useCallback(
    (event: SegmentGroupValueChangeDetails) => {
      if (event.value == null) {
        return;
      }
      onChange?.(event.value as ChartInterval);
    },
    [onChange],
  );

  return (
    <SegmentGroup.Root
      defaultValue={defaultValue}
      bg="surface.muted"
      boxShadow="none"
      size="xs"
      width="fit-content"
      onValueChange={handleChange}
    >
      <SegmentGroup.Indicator />
      {intervals.map((item) => (
        <SegmentGroup.Item key={item} value={item} cursor="pointer">
          <SegmentGroup.ItemText>{item}</SegmentGroup.ItemText>
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
};

export default memo(ChartIntervals);
